import React, { useContext, useEffect, useState } from "react";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import { AlertContext, UserContext } from "../context/MainContext";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../actions/userLogout";
import Edit from "../components/Edit";
import { MdEdit, MdChevronLeft, MdChevronRight } from "react-icons/md";
import {
  SiFacebook,
  SiInstagram,
  SiTiktok,
  SiLinkedin,
  SiPinterest,
  SiYoutube,
} from "react-icons/si";
import {
  TikTokEmbed,
  InstagramEmbed,
  FacebookEmbed,
  YouTubeEmbed,
  XEmbed,
  PinterestEmbed,
  LinkedInEmbed,
} from "react-social-media-embed";
import ModalEdit from "../components/ModalEdit";
import UploadWidgetEdit from "../components/UploadWidgetEdit";
import { userUpdateProfile } from "../actions/userUpdateProfile";
import { userBalance } from "../actions/userBalance";
import { propertyByUser } from "../actions/propertyByUser";

const Profile = () => {
  const { user, setUser } = useContext(UserContext);
  const { alert, setAlert } = useContext(AlertContext);
  const [uploadedItems, setUploadedItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [balance, setBalance] = useState(null);
  const [properties, setProperties] = useState([]);
  const [propertiesLoading, setPropertiesLoading] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const nav = useNavigate();
  const isAdmin = user?.user_id === 3 || user?.user_id === 16;
  const canManageProps = user?.class_type === "Realtor" || isAdmin;
  useEffect(() => {
    userBalance(user?.user_id, { setBalance });
  }, []);
  useEffect(() => {
    if (!user?.user_id) return;
    let active = true;
    const load = async () => {
      setPropertiesLoading(true);
      await propertyByUser(
        {
          setProperties: (data) => {
            if (!active) return;
            setProperties(Array.isArray(data) ? data : []);
          },
        },
        user.user_id,
      );
      if (active) setPropertiesLoading(false);
    };
    load();
    return () => {
      active = false;
    };
  }, [user?.user_id]);
  const handleClick = () => {
    setAlert([
      "Your request for logging out has been submitted.",
      "Once it has been processed you will receive an update.",
      "waiting",
    ]);
    logoutUser({ setUser });
  };
  useEffect(() => {
    if (!user) {
      setAlert([
        "Logout Success!",
        "Congratulations your request was successful, you are now logged out.",
        "confirm",
      ]);
      nav("/");
    }
  }, [user]);
  useEffect(() => {
    if (!uploadedItems || uploadedItems.length === 0) return;
    const latest = uploadedItems[uploadedItems.length - 1];
    // Optimistically show the uploaded image immediately
    setUser((prev) => ({ ...prev, picture_url: latest }));
    userUpdateProfile(user, uploadedItems, setUser);
  }, [uploadedItems]);
  const handleEdit = () => {};
  const normalizeSocialUrl = (url) => {
    if (!url) return "";
    let trimmed = url.trim();
    if (!/^https?:\/\//i.test(trimmed)) {
      trimmed = `https://${trimmed}`;
    }
    return trimmed;
  };
  const getVideoEmbedData = (url) => {
    const normalized = normalizeSocialUrl(url);
    if (!normalized) return { provider: null, embedUrl: "" };

    const lower = normalized.toLowerCase();

    if (lower.includes("tiktok.com")) {
      return {
        provider: "tiktok",
        embedUrl: normalized,
      };
    }

    const instaMatch = normalized.match(
      /instagram\.com\/(p|reel|tv)\/([^/?#]+)/i,
    );
    if (instaMatch) {
      return {
        provider: "instagram",
        embedUrl: normalized,
      };
    }
    if (lower.includes("instagram.com")) {
      return { provider: "instagram", embedUrl: normalized };
    }

    if (lower.includes("facebook.com") || lower.includes("fb.watch")) {
      return {
        provider: "facebook",
        embedUrl: normalized,
      };
    }

    if (lower.includes("linkedin.com")) {
      return { provider: "linkedin", embedUrl: normalized };
    }

    if (lower.includes("pinterest.com")) {
      return { provider: "pinterest", embedUrl: normalized };
    }

    if (lower.includes("x.com") || lower.includes("twitter.com")) {
      return { provider: "x", embedUrl: normalized };
    }

    if (
      lower.includes("youtube.com/watch") ||
      lower.includes("youtu.be") ||
      lower.includes("youtube.com/shorts")
    ) {
      return { provider: "youtube", embedUrl: normalized };
    }

    return { provider: "default", embedUrl: normalized };
  };

  const { provider: videoProvider, embedUrl: videoEmbedUrl } =
    getVideoEmbedData(user?.video);

  const getVideoEmbedData2 = (url) => {
    const normalized = normalizeSocialUrl(url);
    if (!normalized) return { provider: null, embedUrl: "" };

    const lower = normalized.toLowerCase();

    if (lower.includes("tiktok.com")) {
      return {
        provider: "tiktok",
        embedUrl: normalized,
      };
    }

    const instaMatch = normalized.match(
      /instagram\.com\/(p|reel|tv)\/([^/?#]+)/i,
    );
    if (instaMatch) {
      return {
        provider: "instagram",
        embedUrl: normalized,
      };
    }
    if (lower.includes("instagram.com")) {
      return { provider: "instagram", embedUrl: normalized };
    }

    if (lower.includes("facebook.com") || lower.includes("fb.watch")) {
      return {
        provider: "facebook",
        embedUrl: normalized,
      };
    }

    if (lower.includes("linkedin.com")) {
      return { provider: "linkedin", embedUrl: normalized };
    }

    if (lower.includes("pinterest.com")) {
      return { provider: "pinterest", embedUrl: normalized };
    }

    if (lower.includes("x.com") || lower.includes("twitter.com")) {
      return { provider: "x", embedUrl: normalized };
    }

    if (
      lower.includes("youtube.com/watch") ||
      lower.includes("youtu.be") ||
      lower.includes("youtube.com/shorts")
    ) {
      return { provider: "youtube", embedUrl: normalized };
    }

    return { provider: "default", embedUrl: normalized };
  };

  // Get all 4 videos
  const allVideos = [
    { url: user?.video, number: 1 },
    { url: user?.video2, number: 2 },
    { url: user?.video3, number: 3 },
    { url: user?.video4, number: 4 },
  ].filter((v) => v.url);

  const renderVideoEmbed = (url) => {
    const { provider, embedUrl } = getVideoEmbedData2(url);
    if (!embedUrl) return null;

    return (
      <div key={url} className="flex justify-center py-4">
        {provider === "tiktok" && <TikTokEmbed url={embedUrl} />}
        {provider === "instagram" && <InstagramEmbed url={embedUrl} />}
        {provider === "facebook" && <FacebookEmbed url={embedUrl} />}
        {provider === "youtube" && <YouTubeEmbed url={embedUrl} />}
        {provider === "linkedin" && <LinkedInEmbed url={embedUrl} />}
        {provider === "pinterest" && <PinterestEmbed url={embedUrl} />}
        {provider === "x" && <XEmbed url={embedUrl} />}
      </div>
    );
  };

  const formatPrice = (value) => {
    if (!value) return "Price not set";
    const price = Number(value);
    if (!Number.isFinite(price)) return "Price not set";
    return `$${price.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
  };

  const getPropertyImage = (mediaUrl) => {
    if (!mediaUrl) return null;
    const first = mediaUrl.split(",")[0];
    return first ? cloudinaryUrl(first) : null;
  };

  const displayedProperties = (properties || []).slice(0, 6);

  return (
    <>
      {modal && <ModalEdit modal={modal} setModal={setModal} />}
      <div className="min-h-screen bg-white py-8 sm:py-16 px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-1 gap-6 lg:grid-cols-[280px_1fr]">
          <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6 flex flex-col gap-6">
            <div className="relative w-36 h-36 sm:w-48 sm:h-48 mx-auto">
              <div className="h-full w-full rounded-2xl overflow-hidden bg-slate-100 border border-slate-200 shadow-inner">
                {user?.picture_url ? (
                  <img
                    className="h-full w-full object-cover"
                    src={cloudinaryUrl(user?.picture_url)}
                    alt="profile"
                  />
                ) : (
                  <div className="flex h-full items-center justify-center text-slate-400 font-semibold text-sm">
                    Add a photo
                  </div>
                )}
              </div>
              <UploadWidgetEdit
                setUploadedItems={setUploadedItems}
                userId={user?.user_id}
                className="absolute -top-3 -right-3"
              />
            </div>

            <button
              className="w-full bg-red-500 hover:bg-red-600 text-white px-4 py-3 rounded-xl font-semibold transition-all shadow-md hover:shadow-lg"
              onClick={handleClick}
            >
              Log Out
            </button>

            {user?.class_type !== "N/A" &&
              user?.class_type !== "Consumer" &&
              user?.class_type !== "Builder" &&
              user?.class_type !== "Title Company" && (
                <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                  <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                    Brokerage
                  </div>
                  <table className="w-full text-left text-xs">
                    <tbody>
                      <tr>
                        <th className="pr-2 font-semibold">Name</th>
                        <td>{user?.brokerage_name || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">License</th>
                        <td>{user?.brokerage_number || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Broker</th>
                        <td>{user?.broker_name || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Broker License</th>
                        <td>{user?.broker_number || "Not set"}</td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Phone</th>
                        <td>
                          {user?.brokerage_phone ? (
                            <a
                              href={`tel:${String(user.brokerage_phone).replace(
                                /[^+\d]/g,
                                "",
                              )}`}
                            >
                              {user.brokerage_phone}
                            </a>
                          ) : (
                            "Not set"
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th className="pr-2 font-semibold">Email</th>
                        <td>
                          {user?.brokerage_email ? (
                            <a href={`mailto:${user.brokerage_email}`}>
                              {user.brokerage_email}
                            </a>
                          ) : (
                            "Not set"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

            <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
              <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                Keys
              </div>
              <div className="text-slate-800 text-lg font-semibold">
                {typeof user?.key_balance !== "undefined"
                  ? Number(user.key_balance || 0).toLocaleString()
                  : typeof user?.keys !== "undefined"
                    ? Number(user.keys || 0).toLocaleString()
                    : "0"}
              </div>
            </div>

            {user?.class_type === "Builder" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Builder
                </div>
                <div>Company: {user?.builder_company_name}</div>
                <div>Supervisor: {user?.builder_company_supervisor}</div>
                <div>Office: {user?.direct_office}</div>
              </div>
            )}

            {/* NEW: Realtor Sub-Type Information */}
            {user?.class_type === "Realtor" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Realtor Status
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    <tr>
                      <th className="pr-2 font-semibold">NAR Member</th>
                      <td>{user?.is_realtor ? "Yes" : "No"}</td>
                    </tr>
                    {user?.is_realtor === true && (
                      <tr>
                        <th className="pr-2 font-semibold">Broker</th>
                        <td>{user?.is_broker ? "Yes" : "No"}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* NEW: Builder Information (Phase 1) */}
            {user?.class_type === "Builder" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Builder Information
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    {user?.builder_number && (
                      <tr>
                        <th className="pr-2 font-semibold">Builder #</th>
                        <td>{user.builder_number}</td>
                      </tr>
                    )}
                    {user?.builder_email && (
                      <tr>
                        <th className="pr-2 font-semibold">Email</th>
                        <td>
                          <a
                            href={`mailto:${user.builder_email}`}
                            className="text-blue-600 hover:underline"
                          >
                            {user.builder_email}
                          </a>
                        </td>
                      </tr>
                    )}
                    {user?.builder_supervisor_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor</th>
                        <td>{user.builder_supervisor_name}</td>
                      </tr>
                    )}
                    {user?.builder_supervisor_email && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor Email</th>
                        <td>
                          <a
                            href={`mailto:${user.builder_supervisor_email}`}
                            className="text-blue-600 hover:underline"
                          >
                            {user.builder_supervisor_email}
                          </a>
                        </td>
                      </tr>
                    )}
                    {user?.builder_company_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Company</th>
                        <td>{user.builder_company_name}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* NEW: Title Company Information */}
            {user?.class_type === "Title Company" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Title Company Details
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    {user?.title_company_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Company Name</th>
                        <td>{user.title_company_name}</td>
                      </tr>
                    )}
                    {user?.title_company_address && (
                      <tr>
                        <th className="pr-2 font-semibold">Address</th>
                        <td>{user.title_company_address}</td>
                      </tr>
                    )}
                    {user?.title_company_phone && (
                      <tr>
                        <th className="pr-2 font-semibold">Phone</th>
                        <td>
                          <a
                            href={`tel:${String(user.title_company_phone).replace(/[^+\d]/g, "")}`}
                            className="text-blue-600 hover:underline"
                          >
                            {user.title_company_phone}
                          </a>
                        </td>
                      </tr>
                    )}
                    {user?.title_company_supervisor_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor</th>
                        <td>{user.title_company_supervisor_name}</td>
                      </tr>
                    )}
                    {user?.title_company_supervisor_email && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor Email</th>
                        <td>
                          <a
                            href={`mailto:${user.title_company_supervisor_email}`}
                            className="text-blue-600 hover:underline"
                          >
                            {user.title_company_supervisor_email}
                          </a>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* NEW: Lender Information */}
            {user?.class_type === "Lender" && (
              <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-2 text-sm text-slate-700">
                <div className="font-bold text-slate-900 text-xs tracking-wide uppercase">
                  Lender Credentials
                </div>
                <table className="w-full text-left text-xs">
                  <tbody>
                    {user?.company_license_number && (
                      <tr>
                        <th className="pr-2 font-semibold">
                          Company License #
                        </th>
                        <td>{user.company_license_number}</td>
                      </tr>
                    )}
                    {user?.supervisor_name && (
                      <tr>
                        <th className="pr-2 font-semibold">Supervisor</th>
                        <td>{user.supervisor_name}</td>
                      </tr>
                    )}
                    {user?.supervisor_license_number && (
                      <tr>
                        <th className="pr-2 font-semibold">
                          Supervisor License #
                        </th>
                        <td>{user.supervisor_license_number}</td>
                      </tr>
                    )}
                    {user?.branch_address && (
                      <tr>
                        <th className="pr-2 font-semibold">Branch Address</th>
                        <td>{user.branch_address}</td>
                      </tr>
                    )}
                    {user?.branch_phone && (
                      <tr>
                        <th className="pr-2 font-semibold">Branch Phone</th>
                        <td>
                          <a
                            href={`tel:${String(user.branch_phone).replace(/[^+\d]/g, "")}`}
                            className="text-blue-600 hover:underline"
                          >
                            {user.branch_phone}
                          </a>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* Contact & Social Section */}
            <div className="space-y-4">
              <h2 className="text-lg font-bold text-slate-900">Contact</h2>
              <div className="space-y-3">
                <div className="flex items-start gap-2">
                  <span className="text-slate-600 font-medium min-w-fit">
                    Phone:
                  </span>
                  <span className="text-slate-800 break-all">
                    {user?.phone_number ? (
                      <a
                        href={`tel:${String(user.phone_number).replace(
                          /[^+\d]/g,
                          "",
                        )}`}
                        className="text-slate-800 hover:underline"
                      >
                        {user.phone_number}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-slate-600 font-medium min-w-fit">
                    Email:
                  </span>
                  <span className="text-slate-800 break-all text-sm">
                    {user?.email_address ? (
                      <a
                        href={`mailto:${user.email_address}`}
                        className="text-slate-800 hover:underline"
                      >
                        {user.email_address}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </div>
              </div>
            </div>

            {/* Social Media Badges */}
            {user?.facebook ||
            user?.instagram ||
            user?.twitter ||
            user?.tiktok ||
            user?.linkedin ||
            user?.pinterest ||
            user?.youtube ? (
              <div className="space-y-3">
                <h3 className="text-sm font-semibold text-slate-600 uppercase tracking-wide">
                  Follow on Social
                </h3>
                <div className="grid grid-cols-2 gap-2">
                  {user?.facebook && (
                    <a
                      href={user.facebook}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#4267B2] hover:bg-[#365899] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiFacebook size={14} />
                      <span>Facebook</span>
                    </a>
                  )}
                  {user?.linkedin && (
                    <a
                      href={user.linkedin}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#0A66C2] hover:bg-[#094c91] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiLinkedin size={14} />
                      <span>LinkedIn</span>
                    </a>
                  )}
                  {user?.instagram && (
                    <a
                      href={user.instagram}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiInstagram size={14} />
                      <span>Instagram</span>
                    </a>
                  )}
                  {user?.pinterest && (
                    <a
                      href={user.pinterest}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#E60023] hover:bg-[#b8001b] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiPinterest size={14} />
                      <span>Pinterest</span>
                    </a>
                  )}
                  {user?.twitter && (
                    <a
                      href={user.twitter}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-black hover:bg-slate-800 text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <span className="font-bold">𝕏</span>
                    </a>
                  )}
                  {user?.tiktok && (
                    <a
                      href={user.tiktok}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-black hover:bg-slate-800 text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiTiktok size={14} />
                      <span>TikTok</span>
                    </a>
                  )}
                  {user?.youtube && (
                    <a
                      href={user.youtube}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center justify-center gap-2 px-3 py-2 bg-[#FF0000] hover:bg-[#d00000] text-white rounded-lg font-medium transition-all hover:shadow-md text-xs"
                    >
                      <SiYoutube size={14} />
                      <span>YouTube</span>
                    </a>
                  )}
                </div>
              </div>
            ) : null}
          </div>

          <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6 flex flex-col gap-6">
            <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
              <div>
                {user?.class_type === "Consumer" ? (
                  <h1 className="text-3xl font-bold text-slate-900">
                    {user?.username}
                  </h1>
                ) : (
                  <h1 className="text-3xl font-bold text-slate-900">{`${user?.legal_first_name} ${user?.legal_last_name}`}</h1>
                )}
                <p className="text-base font-medium text-blue-600">
                  {Number(user?.user_id) === 16 ||
                  user?.email === "tonythebroker956@gmail.com"
                    ? "Broker / Owner of Glass Realty"
                    : user?.class_type === "N/A" ||
                        user?.class_type === "Consumer" ||
                        user?.class_type === "Title Company"
                      ? ""
                      : user?.class_type}
                </p>
                {user?.class_type === "Title Company" && (
                  <>
                    <p className="text-base font-medium text-blue-600">
                      {user?.business_name}
                    </p>
                    <p className="text-sm italic text-slate-600">
                      {user?.position}
                    </p>
                  </>
                )}
              </div>
              <button
                className="bg-slate-900 text-white p-3 rounded-full shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all"
                onClick={() => setModal(true)}
                aria-label="Edit Profile"
              >
                <MdEdit size={22} />
              </button>
            </div>

            <div className="space-y-6">
              {/* About Section */}
              <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <h2 className="text-lg font-bold text-slate-900">About</h2>
                </div>
                <Edit
                  about={
                    user?.about ||
                    "You have not set an about section for yourself yet, to set one click the edit button."
                  }
                />
              </div>

              {/* Featured Videos Carousel Section */}
              {allVideos.length > 0 && (
                <div className="bg-white border border-slate-200 shadow-xl rounded-2xl p-6 space-y-4">
                  <h2 className="text-lg font-bold text-slate-900">
                    Featured Videos ({allVideos.length})
                  </h2>
                  <div className="relative">
                    <div className="border border-slate-200 rounded-lg p-4 bg-slate-50">
                      <p className="text-xs font-semibold text-slate-500 mb-3 uppercase tracking-wide">
                        Video {allVideos[currentVideoIndex].number}
                      </p>
                      <div className="flex justify-center">
                        {renderVideoEmbed(allVideos[currentVideoIndex].url)}
                      </div>
                    </div>

                    {allVideos.length > 1 && (
                      <div className="flex items-center justify-between mt-4 gap-2">
                        <button
                          onClick={() =>
                            setCurrentVideoIndex(
                              currentVideoIndex === 0
                                ? allVideos.length - 1
                                : currentVideoIndex - 1,
                            )
                          }
                          className="p-2 bg-slate-200 hover:bg-slate-300 rounded-full transition-colors"
                          aria-label="Previous video"
                        >
                          <MdChevronLeft size={24} />
                        </button>

                        <div className="flex gap-2 justify-center flex-1">
                          {allVideos.map((_, idx) => (
                            <button
                              key={idx}
                              onClick={() => setCurrentVideoIndex(idx)}
                              className={`h-2 rounded-full transition-all ${
                                idx === currentVideoIndex
                                  ? "bg-slate-900 w-6"
                                  : "bg-slate-300 w-2 hover:bg-slate-400"
                              }`}
                              aria-label={`Go to video ${idx + 1}`}
                            />
                          ))}
                        </div>

                        <button
                          onClick={() =>
                            setCurrentVideoIndex(
                              currentVideoIndex === allVideos.length - 1
                                ? 0
                                : currentVideoIndex + 1,
                            )
                          }
                          className="p-2 bg-slate-200 hover:bg-slate-300 rounded-full transition-colors"
                          aria-label="Next video"
                        >
                          <MdChevronRight size={24} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Properties Section */}
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-bold text-slate-900">
                    Your Properties
                  </h2>
                  {canManageProps && (
                    <button
                      type="button"
                      className="text-sm font-semibold text-blue-600 hover:text-blue-700"
                      onClick={() => nav("/myproperties")}
                    >
                      Manage all
                    </button>
                  )}
                </div>

                {propertiesLoading ? (
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg text-sm text-slate-600">
                    Loading your properties...
                  </div>
                ) : displayedProperties.length ? (
                  <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
                    {displayedProperties.map((property) => {
                      const previewImage = getPropertyImage(
                        property?.media_url,
                      );
                      const address =
                        [property?.street_number, property?.street_name]
                          .filter(Boolean)
                          .join(" ") ||
                        property?.title ||
                        "Untitled property";
                      const location = [property?.city, property?.state]
                        .filter(Boolean)
                        .join(", ");
                      const statusLabel = property?.property_status || "Status";

                      return (
                        <div
                          key={property?.property_id || address}
                          className="border border-slate-200 rounded-xl overflow-hidden shadow-sm bg-white"
                        >
                          <div className="relative h-32 bg-slate-100">
                            {previewImage ? (
                              <img
                                src={previewImage}
                                alt={address}
                                className="h-full w-full object-cover"
                              />
                            ) : (
                              <div className="flex h-full items-center justify-center text-slate-400 text-sm">
                                No photo yet
                              </div>
                            )}
                            <span className="absolute top-2 left-2 px-2 py-1 text-xs font-semibold rounded-full bg-white/90 text-slate-800 border border-slate-200">
                              {statusLabel}
                            </span>
                          </div>

                          <div className="p-3 space-y-1">
                            <p className="text-sm font-semibold text-slate-900 truncate">
                              {address}
                            </p>
                            <p className="text-xs text-slate-500 truncate">
                              {location || "Location pending"}
                            </p>
                            <p className="text-sm font-bold text-blue-700">
                              {formatPrice(property?.price)}
                              {property?.for === "Lease" ? "/mo" : ""}
                            </p>
                            <div className="flex items-center justify-between text-xs text-slate-600">
                              <span>
                                {property?.type || property?.for || "Type"}
                              </span>
                              <span>
                                {property?.beds_total || 0} bd ·{" "}
                                {property?.baths_full || 0} ba
                              </span>
                            </div>
                            <button
                              type="button"
                              className="w-full mt-2 bg-slate-900 text-white py-2 rounded-lg text-sm font-semibold hover:bg-slate-800 transition-colors"
                              onClick={() =>
                                property?.property_id
                                  ? nav(`/property/${property.property_id}`)
                                  : null
                              }
                            >
                              View details
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg text-sm text-slate-600">
                    {canManageProps
                      ? "You have no properties yet. Add a listing to see it here."
                      : "Listings will appear here once they are available."}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
